import { makeStyles } from '@material-ui/core/styles';
import getBrand from '../../utils/getBrand';

const isCelebrity = getBrand()?.id === 'cel';

const useStyles = makeStyles((Theme) => ({
  formContainer: {
    padding: '40px 20px',
    width: '100%',
    backgroundColor: Theme.palette.white,
    '& svg': {
      fill: Theme.palette.primary.light,
      '&.MuiSelect-icon.Mui-disabled': {
        fill: Theme.palette.gray[400],
      },
    },
    [Theme.breakpoints.down('lg')]: {
      padding: '33px 20px 30px',
    },
    [Theme.breakpoints.down('sm')]: {
      padding: '24px',
    },

    '& .MuiGrid-grid-sm-6': {
      padding: '0 20px',
      paddingTop: '34px',

      [Theme.breakpoints.down('md')]: {
        paddingLeft: '15px',
        paddingRight: '15px',
      },
      [Theme.breakpoints.down('xs')]: {
        paddingLeft: 0,
        paddingRight: 0,
      },

      '& .MuiFormControl-root': {
        width: '100%',
      },
    },

    '& .MuiOutlinedInput-root.requiered-error, & .MuiBox-root.requiered-error': {
      borderColor: Theme.palette.error.main,
    },
  },
  formContainerOnTop: {
    '& .MuiBox-root:first-of-type': {
      padding: 0,
    },
    [Theme.breakpoints.up('md')]: {
      padding: '20px 50px',
    },
    [Theme.breakpoints.up('lg')]: {
      padding: '30px 50px',
    },
    [Theme.breakpoints.up('xl')]: {
      padding: '30px 70px',
    },
  },
  footerForm: {
    backgroundColor: Theme.palette.gray[150],
    borderRadius: `${isCelebrity ? '0' : '0 0 4px 4px'}`,
    height: 80,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '16px 24px',
    [Theme.breakpoints.up('lg')]: {
      paddingRight: 40,
    },
    [Theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  gridButtonWrapper: {
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'flex-end',
    maxWidth: 200,
    width: 200,
    [Theme.breakpoints.down('lg')]: {
      maxWidth: 130,
      width: 130,
    },
    [Theme.breakpoints.down('md')]: {
      marginTop: '20px',
      maxWidth: 'unset',
      width: 'unset',
    },
  },

  inputsContainer: {
    alignItems: 'flex-start',
  },
  inputsContainerOnTop: {
    '& .MuiGrid-grid-xs-12': {
      paddingTop: '34px',
    },
    '& .MuiGrid-grid-xs-12:first-of-type': {
      paddingTop: '27px',
      paddingRight: '30px',
      [Theme.breakpoints.down('lg')]: {
        paddingRight: '20px',
      },
      [Theme.breakpoints.down('md')]: {
        paddingRight: 0,
      },
    },
    [Theme.breakpoints.up('md')]: {
      '& .MuiGrid-grid-xs-12': {
        paddingTop: '27px',
      },
    },
    minWidth: 'calc(100% - 200px)',
    [Theme.breakpoints.down('lg')]: {
      maxWidth: 'calc(100% - 130px)',
      minWidth: 'calc(100% - 130px)',
    },
    [Theme.breakpoints.down('md')]: {
      minWidth: '100%',
    },
  },
  dateContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'Space-between',
  },
  inputsDateContainer: {
    display: 'flex',
    alignItems: 'flex-start',
    width: '100%',
  },
  mobileShipInput: {
    position: 'relative',
    alignItems: 'center',
    boxSizing: 'border-box',
    border: `1px solid ${Theme.palette.gray[300]}`,
    borderRadius: 3,
    display: 'flex',
    flexDirection: 'row',
    height: 50,
    '& > svg': {
      position: 'absolute',
      marginLeft: 20,
      [Theme.breakpoints.down('lg')]: {
        marginLeft: 10,
      },
    },
    '& .MuiInputBase-root': {
      width: '100%',
      border: 0,
    },
    '& fieldset': {
      border: 0,
    },
    '&.requiered-error': {
      '& .MuiInputBase-root svg': {
        fill: Theme.palette.error.main,
      },
    },
  },
  formControl: {
    marginRight: 20,
    '&:first-of-type': { minWidth: 85 },
    '&:last-of-type': { marginRight: 0 },

    [Theme.breakpoints.down('md')]: {
      marginRight: 10,
    },
  },
  select: {
    backgroundColor: 'transparent !important',
    paddingLeft: 54,
    fontFamily: Theme.typography.base.regular,
    fontSize: Theme.typography.size[2],
    color: 'inherit',

    [Theme.breakpoints.down('lg')]: {
      paddingLeft: 44,
    },
  },
  selectDates: {
    backgroundColor: 'transparent !important',
    paddingLeft: 20,
    fontFamily: Theme.typography.base.regular,
    fontSize: Theme.typography.size[2],

    [Theme.breakpoints.down('lg')]: {
      paddingLeft: 10,
    },
  },
  flightsInput: {
    '& .MuiFormLabel-root': {
      fontFamily: Theme.typography.base.regular,
    },
    '& .MuiInputBase-input': {
      fontFamily: Theme.typography.base.regular,
      fontSize: Theme.typography.size[2],
      color: Theme.palette.gray[750],
    },

    '& ul > li': {
      fontFamily: Theme.typography.base.regular,
      fontSize: Theme.typography.size[2],
      color: Theme.palette.gray[750],
    },
    '& .MuiInputBase-root': { height: 50 },
    '& p.Mui-error': {
      [Theme.breakpoints.up('lg')]: {
        position: 'absolute',
        bottom: '-28px',
      },
    },
    '& .MuiFormHelperText-root.Mui-error': {
      fontFamily: Theme.typography.base.regular,
      color: Theme.palette.error.text,
      fontSize: Theme.typography.size[0.5],
    },
    '&.requiered-error': {
      '& .MuiInputBase-root': {
        borderColor: Theme.palette.error.main,
      },
      '& .MuiFormHelperText-root.Mui-error': {
        bottom: '-40px',
      },
    },
  },
  shipsListboxPaper: {
    height: 252,
    marginTop: '-3px',
    marginBottom: 0,
    boxSizing: 'border-box',
    fontFamily: Theme.typography.base.regular,
    fontSize: Theme.typography.size[2],
    backgroundColor: Theme.palette.white,
    '& li': {
      paddingLeft: 54,
      color: Theme.palette.gray[750],
      fontFamily: Theme.typography.base.regular,
      fontSize: Theme.typography.size[2],
      height: 50,
    },
    '& li:first-child': {
      display: 'none',
    },
    [Theme.breakpoints.down('md')]: {
      '& li': {
        paddingLeft: 44,
      },
    },
  },
  dateListboxPaper: {
    marginTop: '-3px',
    marginBottom: 0,
    boxSizing: 'border-box',
    fontFamily: Theme.typography.base.regular,
    backgroundColor: Theme.palette.white,
    '& li': {
      color: Theme.palette.gray[750],
      fontFamily: Theme.typography.base.regular,
      height: 50,
    },
    '& li:first-child': {
      display: 'none',
    },
  },
  shipContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  legend: {
    fontFamily: Theme.typography.base.regular,
    fontSize: Theme.typography.size[1],
    lineHeight: '125%',
    paddingBottom: 8,
    color: Theme.palette.gray[750],
  },
  shipsInput: {
    marginRight: 30,
    [Theme.breakpoints.down('lg')]: {
      marginRight: 20,
    },
    [Theme.breakpoints.down('md')]: {
      marginRight: 0,
    },
  },
  dateInput: {
    marginRight: 10,
    width: '100%',
    height: 50,
    borderRadius: 3,
    border: `1px solid ${Theme.palette.gray[300]}`,
    display: 'flex',
    boxSizing: 'border-box',
    alignItems: 'center',
    '& fieldset': {
      border: 0,
    },
    '&.requiered-error': {
      '& svg': {
        fill: Theme.palette.error.main,
        '&.MuiSelect-icon.Mui-disabled': {
          fill: Theme.palette.error.main,
        },
      },
    },
  },
  counterMenu: {
    fontFamily: Theme.typography.base.regular,
    '& label': {
      fontFamily: Theme.typography.base.regular,
      fontSize: Theme.typography.size[1],
      lineHeight: '150%',
    },
    [Theme.breakpoints.up('sm')]: {
      paddingLeft: '20px',
      paddingRight: '20px',
    },
    '& label:first-child': {
      color: Theme.palette.gray[400],
    },
  },
  requiredFieldError: {
    fontFamily: Theme.typography.base.regular,
    color: Theme.palette.error.text,
    fontSize: Theme.typography.size[0.5],
    marginTop: '4px',
  },
}));

export default useStyles;
